import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=70a3409f&scoped=true&"
import script from "./configuration.vue?vue&type=script&lang=js&"
export * from "./configuration.vue?vue&type=script&lang=js&"
import style0 from "./configuration.vue?vue&type=style&index=0&id=70a3409f&prod&lang=scss&scoped=true&"
import style1 from "./configuration.vue?vue&type=style&index=1&id=70a3409f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3409f",
  null
  
)

export default component.exports